// @flow

import { connect } from "react-redux"
import type { Connector } from "react-redux"
import MagicLogin from "@kiwicom/nitro/lib/components/MagicLogin"
import type { AuthUser, AuthToken } from "@kiwicom/nitro/lib/records/Auth"

import { setCustomerVerified } from "../../services/options/actions"
import type { Provider } from "../../services/user/socialAuthApi"
import { socialAuth } from "../../services/user"
import { handleSimpleToken } from "../SmartFAQ/services/SmartFAQDuck"
import onSignIn from "./services/onSignIn"

type ContainerHandlers = {|
  onSocialLogin: (provider: Provider) => Promise<*>,
  onSignIn: (userInfo: AuthUser) => void,
  onGetSimpleToken: AuthToken => void,
|}

type OwnProps = {|
  disableSocialLogin?: boolean,
  initialScreen: "intro" | "signUp",
  type: "mmb" | "help" | "refer",
  onClose: () => void,
|}

type Props = {|
  ...ContainerHandlers,
  ...OwnProps,
|}

const connector: Connector<OwnProps, Props> = connect(
  null,
  (dispatch: Dispatch<*>, ownProps: OwnProps) => ({
    onSignIn: (userInfo: AuthUser) => dispatch(onSignIn(userInfo)),
    onSocialLogin: (provider: Provider) => dispatch(socialAuth(provider)),
    onGetSimpleToken: (response: AuthToken) => {
      dispatch(setCustomerVerified(true))
      dispatch(handleSimpleToken(response))
      ownProps.onClose()
    },
  }),
)

export default connector(MagicLogin)
